import React from 'react';
import * as S from './style';
import { Row, SpaceDiv, FormItem, BtnNext, BtnContainer } from 'components';
import SelectBox, { Props as SelectBoxProps } from 'components/atoms/SelectBox';
import FormInput, { Props as FormInputProps } from 'components/molecules/FormInput';
import PhoneAuth, { Props as PhoneAuthProps } from 'components/molecules/PhoneAuth';
import PhoneAuthCode, { Props as PhoneAuthCodeProps } from 'components/molecules/PhoneAuthCode';
import TermsAgreement, { Props as TermsAgreementProps } from 'components/molecules/TermsAgreement';
import PrivacyAgreement, { Props as PrivacyAgreementProps } from 'components/molecules/PrivacyAgreement';
import { LABEL_NAME, LABEL_BIRTHDAY } from 'commons/ZimssaString';

export interface Props {
    name: FormInputProps;
    phone: PhoneAuthProps;
    authCode: PhoneAuthCodeProps;
    birthdayYear: SelectBoxProps;
    birthdayMonth: SelectBoxProps;
    birthdayDay: SelectBoxProps;
    termsAgreement: TermsAgreementProps;
    privacyAgreement: PrivacyAgreementProps;
    btnNext: {
        contents: string;
        isActive: boolean;
        isComplete: boolean;
        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    };
}

function SignUp({ ...props }: Props) {
    return (
        <S.SignUpContainer>
            <FormInput label={LABEL_NAME} {...props.name} />
            <Row>
                <PhoneAuth {...props.phone} />
                {props.phone.isSend ? <PhoneAuthCode {...props.authCode} /> : null}
            </Row>
            <FormItem label={LABEL_BIRTHDAY} itemType={'ROW'}>
                <SelectBox {...props.birthdayYear} />
                <SelectBox {...props.birthdayMonth} />
                <SelectBox {...props.birthdayDay} />
            </FormItem>
            <SpaceDiv height={12} />
            <TermsAgreement {...props.termsAgreement} />
            <PrivacyAgreement {...props.privacyAgreement} />
            <SpaceDiv height={12} />
            <BtnContainer>
                <BtnNext {...props.btnNext} />
            </BtnContainer>
        </S.SignUpContainer>
    );
}

export default SignUp;
